class ProductDetailPrices extends Component {
	constructor(el) {
		super(el);
		this.priceWithoutDiscountWithVat = this.$find('[data-price-without-discount-with-vat]');
		this.priceWithVat = this.$find('[data-price-with-vat]');
		this.priceWithoutVat = this.$find('[data-price-without-vat]');
		this.standardizedUnitPriceVat = this.$find('[data-standardized-unit-price-vat]');
		this.addEventListeners();
	}

	/**
	 * @param {ProductVariant} variant
	 */
	updatePrices(variant) {
		if (!variant.priceVAT) {
			return
		}

		if (variant.originalPrice) {
			this.priceWithoutDiscountWithVat.classList.remove('u-hidden');
		} else {
			this.priceWithoutDiscountWithVat.classList.add('u-hidden');
		}
		this.priceWithoutDiscountWithVat.innerHTML = variant.originalPrice;
		this.priceWithVat.innerHTML = variant.priceVAT;
		this.priceWithoutVat.innerHTML = variant.price + ' ';
		this.standardizedUnitPriceVat.innerHTML = variant.standardizedUnitPriceVat;
	}

	addEventListeners() {
		EventBus.getInstance().addEventListener('productVariantChanged', e => this.updatePrices(e.detail));
	}
}
